var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpAskAlphie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.37 34.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #141e3a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    className: "cls-1",
    d: "M17.81,11.08c-2.29-.62-4.65.73-5.28,3.02-.1.37-.15.75-.15,1.14.02.68.59,1.21,1.26,1.19.65-.02,1.18-.54,1.19-1.19,0-.57.26-1.11.72-1.46.47-.36,1.07-.47,1.64-.32.62.17,1.1.65,1.27,1.27.25.88-.18,1.81-1.02,2.19-1.24.6-2.02,1.87-1.99,3.25-.02.68.52,1.25,1.19,1.26s1.25-.52,1.26-1.19c0-.02,0-.05,0-.07h0c-.02-.41.19-.81.55-1.01,1.91-.88,2.92-3.01,2.38-5.04-.39-1.48-1.55-2.64-3.03-3.04Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    className: "cls-1",
    d: "M16.61,22c.68,0,1.23.55,1.23,1.23,0,.68-.55,1.23-1.23,1.23s-1.23-.55-1.23-1.23.55-1.23,1.23-1.23h0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.69,5.27c-6.57,0-11.91,5.34-11.91,11.91s5.34,11.91,11.91,11.91,11.91-5.34,11.91-11.91-5.34-11.91-11.91-11.91ZM26.55,17.18c0,5.44-4.42,9.86-9.86,9.86s-9.86-4.42-9.86-9.86,4.42-9.86,9.86-9.86,9.86,4.42,9.86,9.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpAskAlphie);
export default __webpack_public_path__ + "static/media/Help_Ask Alphie.b1854ab3a453fb6c621ebe1da3025b70.svg";
export { ForwardRef as ReactComponent };